import React, { useState, useEffect } from 'react';
import { 
  collection, 
  getDocs, 
  doc, 
  getDoc, 
  updateDoc, 
  setDoc,
  query, 
  orderBy 
} from 'firebase/firestore';
import { getAuth, sendPasswordResetEmail, signOut } from 'firebase/auth';
import { db } from '../firebase/firebase-config';
import { Link, useNavigate } from 'react-router-dom';
import './Dashboard.css';

function Dashboard() {
  const navigate = useNavigate();
  const auth = getAuth();
  const user = auth.currentUser;

  // --- STATE'LER ---
  const [stats, setStats] = useState({
    articleCount: 0,
    lastUpdate: 'Henüz yok',
    totalViews: 0 
  });
  
  const [loading, setLoading] = useState(true);
  
  // Modallar için State
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);

  // Ayarlar Formu State'i
  const [settings, setSettings] = useState({
    siteTitle: '',
    contactEmail: '',
    maintenanceMode: false
  });

  // --- VERİ ÇEKME ---
  useEffect(() => {
    const fetchData = async () => {
      try {
        // 1. Makale İstatistikleri
        const articlesRef = collection(db, 'articles');
        const q = query(articlesRef, orderBy('createdAt', 'desc'));
        const snapshot = await getDocs(q);
        
        const totalArticles = snapshot.size;
        let lastDate = 'Veri yok';

        if (!snapshot.empty) {
          const lastDoc = snapshot.docs[0].data();
          if (lastDoc.createdAt) {
            lastDate = new Date(lastDoc.createdAt.seconds * 1000).toLocaleDateString('tr-TR');
          }
        }

        // 2. Görüntülenme Sayısını Çek (siteStats koleksiyonundan)
        const statsRef = doc(db, 'siteStats', 'general');
        const statsSnap = await getDoc(statsRef);
        let currentViews = 0;

        if (statsSnap.exists()) {
          currentViews = statsSnap.data().totalViews || 0;
        } else {
          // Eğer döküman yoksa oluşturalım (ilk kurulum)
          await setDoc(statsRef, { totalViews: 0 });
        }

        // 3. Mevcut Site Ayarlarını Çek
        const settingsRef = doc(db, 'siteSettings', 'general');
        const settingsSnap = await getDoc(settingsRef);
        if (settingsSnap.exists()) {
          setSettings(settingsSnap.data());
        }

        setStats({
          articleCount: totalArticles,
          lastUpdate: lastDate,
          totalViews: currentViews
        });
        
        setLoading(false);
      } catch (error) {
        console.error("Dashboard veri hatası:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // --- FONKSİYONLAR ---

  // Site Ayarlarını Kaydet
  const saveSettings = async (e) => {
    e.preventDefault();
    try {
      await setDoc(doc(db, 'siteSettings', 'general'), settings);
      alert("Ayarlar başarıyla kaydedildi!");
      setShowSettingsModal(false);
    } catch (error) {
      console.error("Ayar kaydetme hatası:", error);
      alert("Hata oluştu: " + error.message);
    }
  };

  // Şifre Sıfırlama E-postası Gönder
  const handlePasswordReset = async () => {
    if (user && user.email) {
      try {
        await sendPasswordResetEmail(auth, user.email);
        alert(`Şifre sıfırlama bağlantısı ${user.email} adresine gönderildi.`);
      } catch (error) {
        alert("Hata: " + error.message);
      }
    }
  };

  // Çıkış Yap
  const handleLogout = async () => {
    await signOut(auth);
    navigate('/'); 
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Genel Bakış</h1>
        <p>Hoşgeldin, <strong>{user?.email}</strong>. Sitenin güncel durumu aşağıdadır.</p>
      </div>

      {/* İstatistik Kartları */}
      <div className="stats-grid">
        <div className="stat-card blue">
          <div className="stat-icon">📄</div>
          <div className="stat-info">
            <h3>Toplam Makale</h3>
            <p className="stat-number">{loading ? '...' : stats.articleCount}</p>
          </div>
        </div>

        <div className="stat-card green">
          <div className="stat-icon">👁️</div>
          <div className="stat-info">
            <h3>Toplam Görüntülenme</h3>
            <p className="stat-number">{loading ? '...' : stats.totalViews}</p>
          </div>
        </div>

        <div className="stat-card purple">
          <div className="stat-icon">📅</div>
          <div className="stat-info">
            <h3>Son Güncelleme</h3>
            <p className="stat-number" style={{fontSize: '1.2rem'}}>{loading ? '...' : stats.lastUpdate}</p>
          </div>
        </div>
      </div>

      {/* Hızlı İşlemler */}
      <div className="dashboard-content">
        <div className="content-card">
          <h3>Hızlı İşlemler</h3>
          <div className="action-buttons">
            <Link to="/admin/articles" className="action-btn1">
              <span>📝</span> Makaleleri Yönet
            </Link>
            
            <button className="action-btn secondary" onClick={() => setShowSettingsModal(true)}>
              <span>⚙️</span> Site Ayarları
            </button>
            
            <button className="action-btn secondary" onClick={() => setShowProfileModal(true)}>
              <span>👤</span> Profilim
            </button>
          </div>
        </div>

        <div className="content-card">
          <h3>Sistem Durumu</h3>
          <ul className="system-status-list">
            <li className="status-item online">
              <span className="dot"></span> Firebase Bağlantısı: <strong>Aktif</strong>
            </li>
            <li className="status-item online">
              <span className="dot"></span> Veri Akışı: <strong>{loading ? 'Yükleniyor' : 'Senkronize'}</strong>
            </li>
            <li className={`status-item ${settings.maintenanceMode ? 'warning' : 'online'}`}>
              <span className="dot"></span> Site Durumu: <strong>{settings.maintenanceMode ? 'Bakım Modunda' : 'Yayında'}</strong>
            </li>
          </ul>
        </div>
      </div>

      {/* --- SITE AYARLARI MODALI --- */}
      {showSettingsModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Site Ayarları</h3>
              <button className="close-btn" onClick={() => setShowSettingsModal(false)}>×</button>
            </div>
            <form onSubmit={saveSettings}>
              <div className="form-group">
                <label>Site Başlığı</label>
                <input 
                  type="text" 
                  value={settings.siteTitle} 
                  onChange={(e) => setSettings({...settings, siteTitle: e.target.value})}
                  placeholder="Örn: Avukat Arzu Gül"
                />
              </div>
              <div className="form-group">
                <label>İletişim E-postası</label>
                <input 
                  type="email" 
                  value={settings.contactEmail} 
                  onChange={(e) => setSettings({...settings, contactEmail: e.target.value})}
                />
              </div>
              <div className="form-group checkbox-group">
                <label>
                  <input 
                    type="checkbox" 
                    checked={settings.maintenanceMode} 
                    onChange={(e) => setSettings({...settings, maintenanceMode: e.target.checked})}
                  />
                  Siteyi Bakım Moduna Al
                </label>
                <small style={{display:'block', color:'#999', marginTop:'5px'}}>Bakım modundayken ziyaretçiler siteyi göremez.</small>
              </div>
              <div className="modal-footer">
                <button type="button" className="cancel-btn" onClick={() => setShowSettingsModal(false)}>İptal</button>
                <button type="submit" className="save-btn">Kaydet</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* --- PROFİL MODALI --- */}
      {showProfileModal && (
        <div className="modal-overlay">
          <div className="modal-content" style={{maxWidth: '400px'}}>
            <div className="modal-header">
              <h3>Profil İşlemleri</h3>
              <button className="close-btn" onClick={() => setShowProfileModal(false)}>×</button>
            </div>
            <div style={{padding: '20px'}}>
              <p><strong>Giriş Yapan:</strong> {user?.email}</p>
              <p style={{fontSize:'13px', color:'#666', marginBottom:'20px'}}>
                Şifrenizi değiştirmek için aşağıdaki butona tıklayın. E-posta adresinize sıfırlama bağlantısı gönderilecektir.
              </p>
              
              <button onClick={handlePasswordReset} className="action-btn secondary" style={{width:'100%', marginBottom:'10px', justifyContent:'center'}}>
                🔒 Şifre Sıfırlama Maili Gönder
              </button>
              
              <button onClick={handleLogout} className="action-btn delete-btn" style={{width:'100%', justifyContent:'center', backgroundColor: '#e74c3c'}}>
                🚪 Çıkış Yap
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  )
}

export default Dashboard;